<div role="dialog" aria-labelledby="dialogTitle">
  <div class="modal-header">
    <h4 id="dialogTitle" role="header" class="modal-title module-title">{{"plan.title"|translate}}</h4>
    <button type="button" value="Close" class="close" aria-label="Close" (click)="dismiss()" title="{{'dialog.box.close.tooltip'|translate}}">
      <span class="icon-Close" aria-hidden="true"></span>
    </button>
  </div>
  <div class="modal-body">
    <div class="col-12">
      <div>
        <!-- Plan Name -->
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-textbox #planName (wfmTextboxEvent)="setPlanName($event.target.value)" inputName="planName"
                         [wfmAutoComplete]="'off'"
                         (inputOnBlur)="checkPlanNameExists($event)" [maxLength]="32"
                         inputId="planName" [required]="true" [textValue]="planModel.planName"
                         label="{{'plan.label.name'|translate}}" hasFocus=true
            >
            </wfm-textbox>
          </div>
        </div>
        <!-- Forecast Source -->
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-select #forecastSource selectName="forecastSource" selectId="forecastSource"
                        label="{{'plan.label.forecastsource'|translate}}" [items]="forecastSourceList"
                        placeHolder="{{'plan.label.forecastsource'|translate}}" [disabled]="!hasPlanNameWithLength()"
                        (wfmSelectEvent)="updateForecastSource($event)" [selectedItem]="selectedForecastSource"
            >
            </wfm-select>
          </div>
        </div>
        <!-- Forecast -->
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-select #forecast selectName="forecast" selectId="forecast"
                        label="{{'plan.label.forecast'|translate}}" [items]="forecastList"
                        placeHolder="{{'plan.label.forecast'|translate}}" [showLoading]="_forecastListLoading"
                        [disabled]="!hasPlanNameWithLength()" (wfmSelectEvent)="updateForecast($event)" [selectedItem]="selectedForecast">
            </wfm-select>
          </div>
        </div>
        <!-- WEM Skills -->
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <label class="text-uppercase input-label">
              {{'plan.cxone.wem.skills.read.only'|translate}}
              <span class="text-danger">*</span>
            </label>
            <p-multiselect placeholder=" " #skillsMultiSelect
                           [options]="wemSkillsList"
                           [(ngModel)]="selectedWemSkills"
                           [showToggleAll]="false"
                           [virtualScroll]="true"
                           [virtualScrollItemSize]="40"
                           [virtualScrollOptions]="virtualScrollOptions"
                           emptyFilterMessage="{{'search.no.results.msg'|translate}}"
                           [showHeader]="true"
                           [overlayOptions]="{showTransitionOptions: '0ms', hideTransitionOptions: '0ms'}"
                           [filter]="false"
                           optionLabel="value.label"
                           optionValue="value"
                           optionDisabled="value.disabled"
                           styleClass="fullrow"
                           [disabled]="!selectedForecast"
                           class="filterable">
              <ng-template let-value pTemplate="selectedItems">
                <esp-multi-select-content [items]="value" emptyMessage="plan.cxone.wem.skills"> </esp-multi-select-content>
              </ng-template>
              <ng-template pTemplate="header">
                <esp-multi-select-filter [multiSelect]="skillsMultiSelect" [displaySelectOptions]="false"></esp-multi-select-filter>
              </ng-template>
              <ng-template pTemplate="footer">
                <esp-multi-select-footer [multiSelect]="skillsMultiSelect"></esp-multi-select-footer>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <esp-multi-select-item [item]="item"></esp-multi-select-item>
              </ng-template>
            </p-multiselect>
          </div>
        </div>
        <!-- Profiles -->
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-select #profile selectName="profile" selectId="profile"
                        label="{{'plan.cxone.profiles'|translate}}" [items]="profileList"
                        placeHolder="{{'plan.cxone.profiles'|translate}}" [showLoading]="_profileListLoading"
                        [disabled]="!selectedForecast" (wfmSelectEvent)="updateProfile($event)" [selectedItem]="selectedProfile">
            </wfm-select>
          </div>
        </div>
        <!-- Scheduling Units -->
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <label class="text-uppercase input-label" data-testid="schedulingUnitsLabel">
              {{'plan.cxone.scheduling.units'|translate}}
              <span class="text-danger">*</span>
            </label>
            <p-multiselect placeholder=" " #suSelector
                           styleClass="fullrow"
                           class="filterable"
                           [options]="schedulingUnitList"
                           [(ngModel)]="selectedSUs"
                           [showToggleAll]="false"
                           [virtualScroll]="true"
                           optionLabel="value.label"
                           optionValue="value"
                           [virtualScrollItemSize]="40"
                           [virtualScrollOptions]="virtualScrollOptions"
                           (onChange)="updateSelectedSUs($event)"
                           emptyFilterMessage="{{'search.no.results.msg'|translate}}"
                           [showHeader]="true"
                           [overlayOptions]="{showTransitionOptions: '0ms', hideTransitionOptions: '0ms'}"
                           [disabled]="_suListLoading"
                           [filter]="false">
              <ng-template let-value pTemplate="selectedItems">
                <esp-multi-select-content [items]="value" emptyMessage="plan.cxone.scheduling.units"> </esp-multi-select-content>
              </ng-template>
              <ng-template pTemplate="header">
                <esp-multi-select-filter [multiSelect]="suSelector"></esp-multi-select-filter>
              </ng-template>
              <ng-template pTemplate="footer">
                <esp-multi-select-footer [multiSelect]="suSelector"></esp-multi-select-footer>
              </ng-template>
              <ng-template let-item pTemplate="item">
                <esp-multi-select-item [item]="item"></esp-multi-select-item>
              </ng-template>
            </p-multiselect>
          </div>
        </div>
        <!-- Start Day of Week -->
        <div class="row">
          <div class='col-10 col-sm-10 col-md-10 col-lg-10 col-xl-10 form-group'>
            <wfm-select #sdow selectName="sdow" selectId="sdow"
                        label="{{'plan.start.day.of.week'|translate}}" [items]="startDayOfWeekList"
                        placeHolder="{{'plan.start.day.of.week'|translate}}" [showLoading]="_startDayOfWeekListLoading"
                        [disabled]="_startDayOfWeekDisabled" (wfmSelectEvent)="updateStartDayOfWeek($event)" [selectedItem]="selectedStartDayOfWeek">
            </wfm-select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="modal-buttons">
      <breeze-button buttonText="{{'plan.cancel.btn'|translate}}"
                     id="cancel-btn"
                     [isSecondary]="true"
                     (clicked)="dismiss()"></breeze-button>

      <breeze-button buttonText="{{'plan.create.btn'|translate}}"
                     id="create-plan-btn"
                     [isPrimary]="true"
                     [isDisabled]="!isPlanModelValid()"
                     (clicked)="createPlan()"></breeze-button>
    </div>
  </div>
</div>
